import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Left Icon",
  "use": "icon-Left Icon-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Left Icon\">\n<path d=\"M19.25 4.125H2.75V6.875H19.25V4.125ZM19.25 9.625H8.25V12.375H19.25V9.625ZM19.25 15.125H2.75V17.875H19.25V15.125ZM6.875 8.25L2.75 11L6.875 13.75V8.25Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/Left Icon.svg
// module id = mFMZ
// module chunks = 258